import React from 'react';
import './App.css';
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import ProofSection from './components/ProofSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';

function App() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header onCtaClick={scrollToContact} />
      <main>
        <HeroSection onCtaClick={scrollToContact} />
        <ProblemSection />
        <ServicesSection onCtaClick={scrollToContact} />
        <ProcessSection />
        <ProofSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default App;
